var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLocationSignup = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3462 12.1497L11.45 9.46041H10.4666L11.0127 12.0828H1.39766L1.94377 9.46041H0.960374L0.0635137 12.1497C-0.16398 12.8341 0.239214 13.394 0.960374 13.394H11.45C12.1711 13.394 12.5743 12.8341 12.3462 12.1497ZM9.48317 3.56001C9.48317 2.69063 9.13781 1.85686 8.52307 1.24212C7.90833 0.627373 7.07455 0.282013 6.20517 0.282013C5.33579 0.282013 4.50202 0.627373 3.88728 1.24212C3.27253 1.85686 2.92717 2.69063 2.92717 3.56001C2.92717 6.6905 6.20517 10.116 6.20517 10.116C6.20517 10.116 9.48317 6.6905 9.48317 3.56001ZM4.43505 3.59935C4.43505 3.36692 4.48084 3.13678 4.56981 2.92205C4.65877 2.70733 4.78917 2.51223 4.95355 2.34792C5.11793 2.1836 5.31307 2.05327 5.52783 1.96439C5.74259 1.8755 5.97275 1.8298 6.20517 1.82988C6.67455 1.82988 7.12471 2.01634 7.45661 2.34824C7.78851 2.68014 7.97497 3.1303 7.97497 3.59968C7.97497 4.06905 7.78851 4.51921 7.45661 4.85111C7.12471 5.18301 6.67455 5.36947 6.20517 5.36947C5.73571 5.36947 5.28547 5.18297 4.95351 4.85101C4.62155 4.51905 4.43505 4.06881 4.43505 3.59935Z",
    fill: "#495057"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocationSignup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LocationSignup.d0c4b5d6.svg";
export { ForwardRef as ReactComponent };